import { render, staticRenderFns } from "./ListUserPregnancies.vue?vue&type=template&id=563bf656&"
import script from "./ListUserPregnancies.vue?vue&type=script&lang=js&"
export * from "./ListUserPregnancies.vue?vue&type=script&lang=js&"
import style0 from "./ListUserPregnancies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports